import React from 'react'
import Home from './pages/home/Home'
import About from './pages/about/About'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Projects from './pages/projects/Projects'
import ProjectsCgi from './pages/projects/cgi/ProjectsCgi'
import ProjectsConfigurators from './pages/projects/configurators/ProjectsConfigurators'
import ProjectsInteractive from './pages/projects/interactives/ProjectsInteractive'
import ProjectsVrar from './pages/projects/vrar/ProjectsVrar'
import Services from './pages/services/Services'
import ServicesCgi from './pages/services/cgi/ServicesCgi'
import ServicesInteractives from './pages/services/interactives/ServicesInteractives'
import ServicesConfigurators from './pages/services/configurators/ServicesConfigurators'
import ServicesVr from './pages/services/vr/ServicesVr'
import ServicesAr from './pages/services/ar/ServicesAr'
import Contact from './pages/contact/Contact'
import Trainers from './pages/trainers/Trainers'
import NotFound from './pages/notFound/NotFound'
import Navbar from './components/Navbar'

const App = () => { 
  return (
    <div>
      <BrowserRouter>
        <Navbar />
        <Routes>
        <Route index element={<Home/>}/>
        <Route path='about' element={<About/>}/>
        <Route path='contact' element={<Contact/>}/>
        <Route path='projects' element={<Projects/>}/>
        <Route path='projectscgi' element={<ProjectsCgi/>}/>
        <Route path='projectsconfigurators' element={<ProjectsConfigurators/>}/>
        <Route path='projectsinteractive' element={<ProjectsInteractive/>}/>
        <Route path='projectsvrar' element={<ProjectsVrar/>}/>
        <Route path='services' element={<Services/>}/>
        <Route path='servicescgi' element={<ServicesCgi/>}/>
        <Route path='servicesinteractives' element={<ServicesInteractives/>}/>
        <Route path='servicesconfigurators' element={<ServicesConfigurators/>}/>
        <Route path='servicesvr' element={<ServicesVr/>}/>
        <Route path='servicesar' element={<ServicesAr/>}/>
        <Route path='trainers' element={<Trainers/>}/>
        <Route path='*' element={<NotFound/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App